import { useState } from "react";
import {
  Form,
  Link,
  useActionData,
  useNavigation,
  redirect,
} from "react-router-dom";

import "./AdminLogin.css";

import showIcon from "../../../assets/show-icon.svg";
import hideIcon from "../../../assets/hide-icon.svg";

import { API_BASE_URL } from "../../../config";

export default function AdminLogin() {
  const [showPassword, setShowPassword] = useState(false);
  const errorMessage = useActionData();
  const handleSubmit = useNavigation();

  const isSubmitting = handleSubmit.state === "submitting";

  const handlePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <section id="admin_login">
        <div className="container">
          <div className="admin-login-wrapper">
            <div className="admin-login-form">
              <h1>Admin Login</h1>
              <Form method="post">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    placeholder="example@email.com"
                    name="email"
                  />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                    />
                    <span className="show-password" onClick={handlePassword}>
                      <img
                        src={showPassword ? showIcon : hideIcon}
                        alt="password icon"
                      />
                    </span>
                  </div>
                </div>
                <button type="submit" className="btn-all-white">
                  {isSubmitting ? "Logging in..." : "Login"}
                </button>
                {errorMessage?.error ? (
                  <p className="error-text">{errorMessage.error}</p>
                ) : (
                  ""
                )}
              </Form>
            </div>
          </div>
        </div>
        <div className="forgot-password">
          <p>
            Forgot Password?
            <Link to="/admin/forgot-password-admin"> Forgot Password</Link>
          </p>
        </div>
      </section>
    </>
  );
}

export const adminAction = async ({ request }) => {
  const formData = await request.formData();

  const data = {
    email: formData.get("email"),
    password: formData.get("password"),
  };

  const response = await fetch(`${API_BASE_URL}/admin/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (result.success === false) {
    return { error: result.message || "Login failed. Please try again." };
  }

  localStorage.setItem("admin_token", result.token);
  localStorage.setItem("admin_id", result.id);
  localStorage.setItem("admin_role", result.role);
  localStorage.setItem("admin_login_time", Date.now());

  return redirect("/admin/dashboard");
};
